import React, { useRef } from "react";
import TaxReturns from "components/shared/TaxReturns";
import DisappearingTile from "components/ui/DisappearingTile";
import UILayout from "components/layout/UILayout";
import useTaxReturnsWithAdvance from "utils/hooks/useTaxReturnsWithAdvance";
import { ModalApi } from "components/modal/Modal";
import AprilModal from "components/modal/AprilModal";
import Button, { ButtonLevel } from "components/ui/Button";
import styled from "styled-components";

const StyledButton = styled(Button)`
  margin-top: 24px;
`;

const TaxReturn: React.FC = () => {
  const aprilModal = useRef<ModalApi>(null);
  const taxReturnsWithAdvance = useTaxReturnsWithAdvance();

  return (
    <>
      <UILayout>
        <DisappearingTile size="xl">
          <TaxReturns taxReturnsWithAdvance={taxReturnsWithAdvance} />

          <StyledButton
            fullWidth
            level={ButtonLevel.cta}
            onClick={() => aprilModal.current.show()}
          >
            Show Details
          </StyledButton>
        </DisappearingTile>
      </UILayout>

      <AprilModal ref={aprilModal} />
    </>
  );
};

export default TaxReturn;
